// import Swiper from 'swiper'
// import { Navigation, Pagination } from 'swiper/modules';

import lazyLoad from "../utils/lazy";

const cProducts = () => {

  const slider = new Swiper('.products__slider', {
    // modules: [Navigation, Pagination],
    spaceBetweenSlides: 16,
    loop: true,
    slidesPerView: "auto",
    pagination: {
      el: ".slide-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    navigation: {
      nextEl: ".products .slide-navigation__button_next",
      prevEl: ".products .slide-navigation__button_prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 150,
        centeredSlides: true,
      },
    },
  })
  
  slider.on('slideChange, init', function () {
    lazyLoad()
  });
}

export default cProducts
